// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".classwork-editor-mc[data-v-4f1960b4] {\n  width: 100%;\n  display: inline-block;\n}\n.grabbable[data-v-4f1960b4] {\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.grabbable[data-v-4f1960b4]:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}", ""]);
// Exports
module.exports = exports;
